import { getCommonParams } from "../Utils/helper";
import { useGetUserByIdQuery } from "../redux/services/UsersMasterService";

export const useGetUserDetails = () => {
    const { userId } = getCommonParams()
    const { data: userData } = useGetUserByIdQuery(userId)
    return userData?.data?.isAdmin ? true : false
};

export default useGetUserDetails;